module.exports = __webpack_public_path__ + "img/vengeance.1e7bb806.jpg";